import { load } from "webfontloader";

export const loadFonts = (): void => {
  load({
    google: {
      families: ["Space Grotesk:300,400,500,600,700&display=swap"],
    },
  });
};
